import React from "react";
import { formatMoney } from "utils";

const OpenCloseBalance = ({ type, sum }) => {
  return (
    <div className="row py-2  py-md-3 align-items-center border-bottom border-1 ps-3">
      <div className="fs-xmd-smaller fst-italic text-nowrap text-center text-md-end ps-0 col-3">
        {formatMoney(sum)}
      </div>
      <b className="fs-6 col-9 text-end text-md-start pe-1  fs-xmd-smaller">
        {type == "open" ? "Open Balance" : "Close Balance"}
      </b>
    </div>
  )
}

export default OpenCloseBalance;
